export default "__VITE_ASSET__be0d454d__"